import React from "react";
import PropTypes from "prop-types";

export const SVPLabel = ({label, text, icon = null, fontSize = "14px"}) => {
    return <div style={{fontSize: fontSize}}>
        <strong>{label}</strong>: {text} {icon}
    </div>;
};

SVPLabel.propTypes = {
    label: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.object,
    fontSize: PropTypes.string,
};
